<template>
    <div>
        <div class="rate-btn-wrapper top-margin-sm">
            <div @click="rate(coffee.id, 'excellent')" @mouseover="showTooltip('Excellent! You loved this coffee and would like to drink it again.')" @mouseleave="hover = false" class="rating-img-wrapper">
                <img v-show="rating === 'excellent'" src='~workplace/rating-excellent-fill.svg' class="rating-img selected" alt="Rating excellent">
                <img v-show="rating !== 'excellent'" src='~workplace/rating-excellent.svg' class="rating-img" alt="Rating excellent">
            </div>
            <div @click="rate(coffee.id, 'good')" @mouseover="showTooltip('Good! You enjoyed this coffee but don\'t necessarily want to drink it again right away.')" @mouseleave="hover = false" class="rating-img-wrapper">
                <img v-show="rating === 'good'" src='~workplace/rating-good-fill.svg' class="rating-img selected" alt="Rating good">
                <img v-show="rating !== 'good'" src='~workplace/rating-good.svg' class="rating-img" alt="Rating good">
            </div>
            <div @click="rate(coffee.id, 'dull')" @mouseover="showTooltip('Dull! You did not enjoy this coffee and don\'t want to drink it again.')" @mouseleave="hover = false" class="rating-img-wrapper">
                <img v-show="rating === 'dull'" src='~workplace/rating-dull-fill.svg' class="rating-img selected" alt="Rating dull">
                <img v-show="rating !== 'dull'" src='~workplace/rating-dull.svg' class="rating-img" alt="Rating dull">
            </div>
            <div @click="rate(coffee.id, 'unsure')" @mouseover="showTooltip('Not Sure. You don\'t remember drinking this coffee or you don\'t have an opinion.')" @mouseleave="hover = false" class="rating-img-wrapper">
                <img v-show="rating === 'unsure'" src='~workplace/rating-unsure-fill.svg' class="rating-img selected" alt="Rating unsure">
                <img v-show="rating !== 'unsure'" src='~workplace/rating-unsure.svg' class="rating-img" alt="Rating unsure">
            </div>

            <transition name="fade">
                <div v-if="hover" class="rating-tip font-xs">{{ tip }}</div>
            </transition>
        </div>

        <div class="red-font top-margin-sm">
            <p v-if="!rating">
                what do you think?
            </p>
            <p v-else>
                <span v-if="totalRatings[rating] && totalRatings[rating] >= 3">
                    <strong>{{ totalRatings[rating] }}</strong> team members agree with you!
                </span>
                <span v-else><br></span>
            </p>
        </div>
    </div>
</template>

<script>
    // Images
    import 'workplace/rating-excellent.svg';
    import 'workplace/rating-good.svg';
    import 'workplace/rating-dull.svg';
    import 'workplace/rating-unsure.svg';
    import 'workplace/rating-excellent-fill.svg';
    import 'workplace/rating-good-fill.svg';
    import 'workplace/rating-dull-fill.svg';
    import 'workplace/rating-unsure-fill.svg';


    export default {
        props: {
            coffee: Object,
            totalRatings: Object
        },
        data: function () {
            return {
                rating: '',
                hover: false,
                tip: undefined
            }
        },
        methods: {
            rate (coffeeId, value) {
                const oldRating = this.rating;

                this.rating = (this.rating === value) ? '' : value;

                this.$api.post('rate', {coffeeId, value: this.rating})
                    .then(() => this.$emit('remove', coffeeId))
                    .catch(() => this.rating = oldRating)
            },

            showTooltip(tip) {
                this.hover = true;
                this.tip = tip;
            }
        }
    }
</script>

<style scoped>
    .rate-btn-wrapper {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        position: relative;
    }

    .rating-img-wrapper {
        max-width: 4rem;
        max-height: 4rem;
        flex-grow: 1;
    }

    .rating-img {
        max-width: 100%;
        max-height: 100%;
        display: block;
        flex-grow: 1;
        opacity: 0.8;
        cursor: pointer;
    }

    .selected {
        opacity: 1;
    }

    .rating-tip {
        position: absolute;
        top: 4.5rem;
        width: 85%;
        padding: 2px 6px;
        color: white;
        background-color: #1F323B;
        border-radius: 4px;
        opacity: 0.8;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    @media (max-width: 768px) {
        .rating-tip {
            display: none;
        }
    }
</style>
